export { default } from './TotalAmount';
